import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ReactGA from "react-ga";

ReactGA.initialize("GTM-5RK9R65");

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "800px",
    [theme.breakpoints.down("xs")]: {
      padding: "12px",
    },
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: "8px",
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: "32px",
  },
  section: {
    marginBottom: "15px",
  },
  sectionTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  content: {
    color: theme.palette.text.secondary,
    lineHeight: 1.8,
    marginBottom: "4px",
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

function CorporateInformation() {
  const classes = useStyles();

  useEffect(() => {
    ReactGA.event({
      category: "Corporate Information/Imprint",
      action: "Viewing Corporate Information/Imprint",
    });
    return () => { };
  }, []);

  return (
    <div className={classes.container}>
      <Typography variant="h3" className={classes.title}>
        Corporate Information / Imprint
      </Typography>

      <Divider style={{ margin: "15px 0" }} />

      <div className={classes.section}>
        <Typography variant="subtitle1" className={classes.sectionTitle}>
          Name and Address
        </Typography>
        <Typography variant="body1" className={classes.content}>
          Bosch Automotive Service Solutions Inc.
        </Typography>
        <Typography variant="body1" className={classes.content}>
          28635 Mound Road
        </Typography>
        <Typography variant="body1" className={classes.content}>
          Warren, MI 48092
        </Typography>
      </div>

      <div className={classes.section}>
        <Typography variant="subtitle1" className={classes.sectionTitle}>
          Authorized Representative
        </Typography>
        <Typography variant="body1" className={classes.content}>
          Director Engineering Diagnostic Service OEM
        </Typography>
      </div>

      <div className={classes.section}>
        <Typography variant="subtitle1" className={classes.sectionTitle}>
          Your Contact at Bosch
        </Typography>
        <Typography variant="body1" className={classes.content}>
          <a
            href="https://www.bosch.us/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            Contact | Bosch in the USA
          </a>
        </Typography>
      </div>
    </div>
  );
}

export default CorporateInformation;
